// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"80":"821fca2b356aa34a","219":"10c48157b2d07348","421":"7b53afb98dea8f9a","772":"7d00371bdaa99e09","880":"94a79a234ee2aba0"}[chunkId] + ".js";
};